import * as turf from '@turf/turf';
interface Coordinate {
    longitude: number;
    latitude: number;
}

/**
 * Calculates the heading (bearing) from the current position to the next position.
 *
 * @param current - The current device position.
 * @param next - The next device position (optional).
 * @returns The heading in degrees from the current position to the next position, or null if the next position is not provided.
 */
export function getHeadingFromCoordinates(current: Coordinate, next?: Coordinate): number | null {
    if (!next?.latitude || !next?.longitude) {
        return null;
    }
    const currentPoint = turf.point([current.longitude, current.latitude]);
    const nextPoint = turf.point([next.longitude, next.latitude]);
    const bearing = turf.bearing(currentPoint, nextPoint);
    const bearing360 = bearing < 0 ? bearing + 360 : bearing;
    return bearing360;
}
